<template>
  <el-dialog :title="$t('editMallMenu.edit')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="editMallMenuInfo" label-width="120px">
      <el-form-item :label="$t('editMallMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('editMallMenu.menuNameRequired') }]">
        <el-input v-model="editMallMenuInfo.hktName" :placeholder="$t('editMallMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('editMallMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="editMallMenuInfo.hktDesc" :placeholder="$t('editMallMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.label')" prop="label">
        <el-input v-model="editMallMenuInfo.label" :placeholder="$t('editMallMenu.inputLabel')" />
      </el-form-item>
      <el-form-item
        v-if="editMallMenuInfo.skipType === '5'"
        :label="$t('editMallMenu.shopType')"
        prop="typeId"
        :rules="[{ required: true, message: $t('editMallMenu.shopTypeRequired') }]"
      >
        <el-select v-model="editMallMenuInfo.typeId" :placeholder="$t('editMallMenu.selectShopType')" style="width:100%">
          <el-option :label="$t('editMallMenu.selectShopType')" value="" />
          <el-option
            v-for="shopType in editMallMenuInfo.shopTypes"
            :key="shopType.shopTypeId || shopType.typeId"
            :label="shopType.typeName"
            :value="shopType.shopTypeId || shopType.typeId"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('editMallMenu.sortRequired') }]">
        <el-input v-model="editMallMenuInfo.seq" :placeholder="$t('editMallMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('editMallMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('editMallMenu.showStatusRequired') }]">
        <el-select v-model="editMallMenuInfo.isShow" :placeholder="$t('editMallMenu.selectShowStatus')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveEditMallMenu">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMallMenu } from '@/api/admin/shopProductType/shopProductTypeApi'
import { queryShopType } from '@/api/admin/shopTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'EditMallMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      editMallMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '',
        isShow: '',
        typeCd: '',
        shopId: '',
        typeId: '',
        shopTypes: []
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()

        // 解析 URL 中的 typeId（店铺类型菜单）
        let typeId = ''
        if (row.url && row.url.indexOf('?') > -1) {
          const paramsStr = row.url.split('?')[1]
          if (paramsStr) {
            const params = {}
            paramsStr.split('&').forEach(param => {
              const [key, value] = param.split('=')
              if (key && value) {
                params[key] = decodeURIComponent(value)
              }
            })
            typeId = params.typeId || ''
          }
        }

        this.editMallMenuInfo = {
          ...row,
          typeId: typeId,
          shopTypes: []
        }

        if (row.hktIcon) {
          this.$refs.uploadImage.setImages([row.hktIcon])
        } else {
          this.$refs.uploadImage.clearImages()
        }

        this.loadShopTypes()
      })
    },
    async loadShopTypes() {
      try {
        const res = await queryShopType({
          page: 1,
          row: 100,
          isShow: 'Y'
        })
        this.editMallMenuInfo.shopTypes = res.data || []
      } catch (error) {
        console.error('加载店铺类型失败', error)
      }
    },
    handleUploadImage(photos) {
      this.editMallMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveEditMallMenu() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        // 店铺类型菜单：根据选择的店铺类型重建跳转 URL
        if (this.editMallMenuInfo.skipType === '5' && this.editMallMenuInfo.typeId) {
          this.editMallMenuInfo.url = `/pages/index/category?typeId=${this.editMallMenuInfo.typeId}`
        }

        const { code, msg } = await updateMallMenu(this.editMallMenuInfo)
        if (code != 0) {
          this.$message.error(msg)
          return;
        }
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>